<ng-container *ngIf="action !== 'moderate'">
	<app-form-view [popup]="true">
		<form-title>
			{{title}}
		</form-title>
		<content-area>
			<div class="add-event-card" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="30px">
				<div fxLayout="row" fxLayoutAlign="center start">
					<div fxFlex="80%" fxFlex.xs="100%" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
						<ng-container *ngIf="info">
							<div class="form-info">
								<p class="body-text">
									{{info}}
								</p>
							</div>
						</ng-container>
						<div fxLayout="row" fxLayoutAlign="center center">
							<div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="95" fxFlex.xs="100" fxLayoutGap="10px"
								fxLayoutGap.xs="10px">
								<div class="content-area" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
									<div fxLayout fxLayoutAlign="center start" class="form-container">
										<app-form-group [fieldList]="formFields" [formObjectData]="formObjectData" [config]="config"
											fxLayout="column" fxLayoutAlign="start stretch" fxLayout.xs="column"
											fxLayoutAlign.xs="start stretch" (formObject)="formObjectReader($event)"></app-form-group>
									</div>

									<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
										<ng-container *ngIf="registrationFormFields?.length">
											<div class="block-title"> {{ locale.translate('registration') }} </div>
										</ng-container>
										<div fxLayout fxLayoutAlign="center start" class="form-container">
											<app-form-group [fieldList]="registrationFormFields" [formObjectData]="formObjectData"
												[config]="config" fxLayout="column" fxLayoutAlign="start stretch" fxLayout.xs="column"
												fxLayoutAlign.xs="start stretch" fxLayoutGap="0px" fxLayoutGap.xs="0px"
												(formObject)="registrationFormObjectReader($event)">
											</app-form-group>
										</div>
									</div>

									<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
										<ng-container *ngIf="skillFormFields?.length">
											<div class="block-title"> {{ locale.translate('skills') }} </div>
										</ng-container>
										<div fxLayout fxLayoutAlign="center start" class="form-container">
											<app-form-group [fieldList]="skillFormFields" [formObjectData]="formObjectData" [config]="config"
												fxLayout="column" fxLayoutAlign="start stretch" fxLayout.xs="column"
												fxLayoutAlign.xs="start stretch" fxLayoutGap="0px" fxLayoutGap.xs="0px"
												(formObject)="skillFormObjectReader($event)">
											</app-form-group>
										</div>
									</div>
									<div class="collapsible-area-container" fxLayout="column" fxLayoutAlign="start stretch"
										fxLayoutGap="20px">
										<ng-container *ngIf="action === 'addEvent' || action === 'editEvent'">
											<app-collapsible-area [data]="{title: locale.translate('linked_resources')}"
												[toggle]="{expanded: false, showToggle: true}" color="#fff">
												<div class="linked-resource-content-area" fxLayout="column" fxLayoutAlign="start stretch"
													fxLayoutGap="17px">
													<ng-container
														*ngFor="let resource of selectedResources; trackBy: gfService.trackByID.bind({'key': 'resourceID'});let resourceIndex = index">
														<div class="updates-content fx-column fx-start-stretch">
															<div class="card-block fx-column fx-start-stretch">
																<ng-container
																	*ngIf="!['playlist', 'answer','internalEvent', 'externalEvent'].includes(resource?.resourceType?.key)">
																	<app-content-image-card [record]="resource" [type]="'minimal'"
																		(remove)="removeResource(resourceIndex)">
																	</app-content-image-card>
																</ng-container>
																<ng-container *ngIf="resource?.resourceType?.key === 'playlist'">
																	<app-playlist-card [data]="resource" [type]="'minimal'"
																		(remove)="removeResource(resourceIndex)">
																	</app-playlist-card>
																</ng-container>
																<ng-container *ngIf="resource?.resourceType?.key === 'answer'">
																	<app-question-card [type]="'minimal'" [data]="resource"
																		(remove)="removeResource(resourceIndex)">
																	</app-question-card>
																</ng-container>
																<ng-container
																	*ngIf="['internalEvent', 'externalEvent'].includes(resource?.resourceType?.key)">
																	<app-event-card [type]="'minimal'" [data]="resource"
																		(remove)="removeResource(resourceIndex)">
																	</app-event-card>
																</ng-container>
															</div>
														</div>
													</ng-container>

													<div fxLayout fxLayoutAlign="center start" class="form-container">
														<app-form-group [fieldList]="linkedResourceField" [formObjectData]="formObjectData"
															[config]="config" fxLayout="column" fxLayoutAlign="start stretch" fxLayout.xs="column"
															fxLayoutAlign.xs="start stretch" fxLayoutGap="0px" fxLayoutGap.xs="0px"
															(formObject)="formObjectReader($event)">
														</app-form-group>
													</div>

												</div>
											</app-collapsible-area>
										</ng-container>
										<ng-container *ngIf="this.action === 'addEvent'">
											<app-collapsible-area [data]="{title: locale.translate('publish')}"
												[toggle]="{expanded: true, showToggle: true}" color="#fff">
												<div class="visibility-content-area" fxLayout="column" fxLayoutAlign="start stretch"
													fxLayoutGap="10px">
													<span class="visibility-desc">
														{{locale.translate('select_channels_to_publish_if_not_published_desc')}}
													</span>
													<div fxLayout fxLayoutAlign="center start" class="form-container">
														<app-form-group [fieldList]="visibilityField" [formObjectData]="formObjectData"
															[config]="config" fxLayout="column" fxLayoutAlign="start stretch" fxLayout.xs="column"
															fxLayoutAlign.xs="start stretch" fxLayoutGap="0px" fxLayoutGap.xs="0px"
															(formObject)="formObjectReader($event)">
														</app-form-group>
													</div>
												</div>
											</app-collapsible-area>
										</ng-container>
									</div>
									<app-alert id="eventAlert"></app-alert>
								</div>
								<div fxLayout="column" fxLayoutAlign="start stretch">
									<div class="btn-block" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
										<ng-container *ngIf="action === 'addEvent'">
											<button [disabled]="submitDisable" (click)="submit()" mat-stroked-button class="submit-btn"
												type="button">{{locale.translate('submit')}}</button>
										</ng-container>
										<ng-container *ngIf="action === 'editEvent'">
											<button [disabled]="submitDisable" (click)="submit()" mat-stroked-button class="submit-btn"
												type="button">{{locale.translate('update')}}</button>
										</ng-container>

										<button [disabled]="submitDisable" (click)="popupRef.close('cancel')" mat-button class="cancel-btn"
											type="button">{{locale.translate('cancel')}}</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</content-area>
	</app-form-view>
</ng-container>

<ng-container *ngIf="action === 'moderate'">
	<app-form-view [popup]="'true'">
		<form-title>
			{{ title }}
		</form-title>
		<content-area>
			<div class="add-internal-event-card" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="30px">
				<div fxLayout="row" fxLayoutAlign="center start">
					<div fxFlex="80%" fxFlex.xs="100%" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">

						<div fxLayout="row" fxLayoutAlign="center center">
							<div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="95" fxFlex.xs="100" fxLayoutGap="10px"
								fxLayoutGap.xs="10px">
								<div class="content-area" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
									<div fxLayout fxLayoutAlign="center start" class="form-container">
										<app-form-group [fieldList]="formFields" [formObjectData]="formObjectData" [config]="config"
											fxLayout="column" fxLayoutAlign="start stretch" fxLayout.xs="column"
											fxLayoutAlign.xs="start stretch">
										</app-form-group>
									</div>
									<app-alert id="manageForm"></app-alert>
								</div>
								<div fxLayout="column" fxLayoutAlign="start stretch">
									<div class="btn-block" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
										<button [disabled]="submitDisable" (click)="submit()" mat-stroked-button class="submit-btn"
											type="button">
											{{locale.translate('submit')}}
										</button>
										<button [disabled]="submitDisable" (click)="popupRef.close('cancel')" mat-button class="cancel-btn"
											type="button">{{locale.translate('cancel')}}</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</content-area>
	</app-form-view>
</ng-container>
